module.exports = __webpack_public_path__ + "img/Benjamin_crop.69f08754.jpg";